// Libraries
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rem } from 'polished';
import { connect } from 'react-redux';
import format from 'date-fns/format';

// Components
import Modal from '../../../index';
import DeleteModalMetadata from './delete-modal-metadata';

// REDUX: Actions
import { modalActions } from '../../../../../../redux/actions/modal-actions';
import { deletePhotoByUserIdAndTimestamp } from '../../../../../../redux/actions/challenges-actions';

let afterClose;

/**
 *  A Modal that warns that he/she is about to delete their account.
 *
 * @class DeletePhotoModal
 * @extends {Component}
 */
class DeletePhotoModal extends Component {
	constructor(props) {
		super(props);
		this.onClose = this.onClose.bind(this);
		this.handleDeletePhoto = this.handleDeletePhoto.bind(this);
	}

	// Closes the window, when the user clicks on the 'cancel' button
	onClose() {
		modalActions.hideModal();
		this.props.dispatch(modalActions.hideModal());

		if (afterClose) {
			afterClose();
		}
	}

	handleDeletePhoto(challenge_id, user_id, timestamp) {
		this.props.dispatch(deletePhotoByUserIdAndTimestamp(challenge_id, user_id, timestamp));
	}

	render() {
		const { modalTitle, modalSubtitle, modalText, modalData, onClose } = this.props;

		return (
			<Modal modalTitle={`${modalTitle}`} modalSubtitle={`${modalSubtitle}`} onClose={onClose} large>
				<div id="delete-photo-modal">
					<main className="grid-x grid-margin-x">
						<figure className="cell large-4 medium-3-small-12">
							<Picture
								src={`${modalData.src}`}
								width={`${modalData.width}`}
								height={`${modalData.height}`}
								alt={`Taken by ${modalData.userName}`}
							/>
						</figure>
						<div className="cell large-8 medium-9 small-12">
							<Message>{modalText}</Message>
							<div className="grid-x">
								<DeleteModalMetadata label="Author" value={`${modalData.userName}`}>
									<small>ID: {`${modalData.userId}`} </small>
								</DeleteModalMetadata>
								<DeleteModalMetadata label="Caption" value={`${modalData.caption}`} />

								<DeleteModalMetadata
									label="Submited"
									value={`${format(modalData.creationTime, 'MMMM Do, YYYY [at] HH:mm:ss')}`}
								/>
								<DeleteModalMetadata label="Activity Key" value={`${modalData.activityKey}`} />
							</div>
						</div>
					</main>
					<Footer className="grid-x grid-margin-x">
						<div className="profile-form__cta__left cell shrink">
							<button
								type="button"
								onClick={() => this.onClose()}
								className="profile-form__button profile-form__button__primary"
							>
								Cancel, Keep it!
							</button>
						</div>
						<div className="profile-form__cta__right cell shrink">
							<button
								type="button"
								onClick={() => this.handleDeletePhoto(modalData.challengeId, modalData.userId, modalData.creationTime)}
								className="profile-form__button profile-form__button__flat"
							>
								Yes, Delete Photo
							</button>
						</div>
					</Footer>
				</div>
			</Modal>
		);
	}
}
/////////////////////////
//  Styled Components //
/////////////////////////
// Some help text
const Message = styled.p`
	padding: 0;
	font-size: ${rem('16px')};
	color: ${props => props.theme.gray9};
	letter-spacing: 0;
	text-align: left;
	margin-bottom: 1.25rem;
`;

const Footer = styled.footer`
	margin-top: ${rem('24px')};
	bottom: 0;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-bottom: 0;
	width: 100%;
`;
const Picture = styled.img`
	width: 100%;
	height: 100%;
	max-height: ${rem('208px')};
	object-fit: cover;
	object-position: center center;
`;

function mapStateToProps(state) {
	return {
		modalTitle: state.modal.properties.modalTitle,
		modalSubtitle: state.modal.properties.modalSubtitle,
		modalText: state.modal.properties.modalText,
		modalData: state.modal.properties.modalData,
	};
}

DeletePhotoModal.defaultProps = {
	modalTitle: 'Atenção',
};

DeletePhotoModal.propTypes = {
	modalTitle: PropTypes.string,
	onClose: PropTypes.func,
};

export default connect(mapStateToProps)(DeletePhotoModal);



// WEBPACK FOOTER //
// ./src/components/general/modal/types/delete/delete-photo/index.jsx